import { z } from 'zod';
import { ErrorCode } from '../../../../shared/error-codes';
import { PartnerMaterialTextSchema } from '../partner-material/partner-material.schema';
const OptionalTextSchema = PartnerMaterialTextSchema.partial();
export const PartnerNewsLinkUrlSchema = z.url({
    protocol: /^https?$/,
    error: ErrorCode.FIELD_INVALID_URL
});
/** A button on the news card: where it leads and what it says, per language. */ export const PartnerNewsActionSchema = z.object({
    url: PartnerNewsLinkUrlSchema,
    label: PartnerMaterialTextSchema
});
/** The two pictures a news card can carry: a logo row on top and an image beside the text. */ export const PARTNER_NEWS_IMAGE_SLOTS = [
    'logo',
    'image'
];
export const PartnerNewsImageSlotSchema = z.enum(PARTNER_NEWS_IMAGE_SLOTS);
export const PARTNER_NEWS_IMAGE_FORMATS = [
    'png',
    'jpeg',
    'webp',
    'svg'
];
export const PartnerNewsImageFormatSchema = z.enum(PARTNER_NEWS_IMAGE_FORMATS);
export const PARTNER_NEWS_IMAGE_CONTENT_TYPES = {
    png: 'image/png',
    jpeg: 'image/jpeg',
    webp: 'image/webp',
    svg: 'image/svg+xml'
};
/** The format of a content type, or null when a news card may not show it. */ export function partnerNewsImageFormatOf(contentType) {
    return PARTNER_NEWS_IMAGE_FORMATS.find((format)=>PARTNER_NEWS_IMAGE_CONTENT_TYPES[format] === contentType) ?? null;
}
export const PARTNER_NEWS_MAX_IMAGE_BYTES = 2 * 1024 * 1024;
/** A stored picture as clients see it: a short-lived signed link, never the storage key. */ export const PartnerNewsImageSchema = z.object({
    url: z.string(),
    fileName: z.string(),
    format: PartnerNewsImageFormatSchema
});
/**
 * Who a news item is for: every partner, or only the partners whose tenant
 * runs the sales app (the superadmin's cut for sales-app users). The partner
 * feed filters by the tenant's installed apps; the admin list shows all.
 */ export const PartnerNewsAudienceSchema = z.enum([
    'all',
    'sales'
]);
export const PARTNER_NEWS_AUDIENCES = PartnerNewsAudienceSchema.options;
const newsFields = {
    _id: z.string(),
    audience: PartnerNewsAudienceSchema,
    /** The short line above the title, e.g. "Quick request". */ eyebrow: OptionalTextSchema.optional(),
    title: PartnerMaterialTextSchema,
    /** Plain text; blank lines separate paragraphs. */ body: PartnerMaterialTextSchema,
    primaryAction: PartnerNewsActionSchema.optional(),
    secondaryAction: PartnerNewsActionSchema.optional(),
    /** Small print under the buttons. */ footnote: OptionalTextSchema.optional(),
    logo: PartnerNewsImageSchema.optional(),
    image: PartnerNewsImageSchema.optional(),
    /** Pinned news come first in the story, whatever their date. */ pinned: z.boolean()
};
/** The superadmin view: drafts included. */ export const PartnerNewsAdminSchema = z.object({
    ...newsFields,
    published: z.boolean(),
    /** Set on the first publish and kept when the news is hidden again. */ publishedAt: z.string().optional(),
    updatedAt: z.string().optional()
});
/** The partner view: published news only. */ export const PartnerNewsSchema = z.object({
    ...newsFields,
    publishedAt: z.string()
});

//# sourceMappingURL=partner-news.schema.js.map